// src/hooks/useOrderPrinting.js
import { useEffect, useRef } from "react";
import {
  printerConfigService,
  PRINT_DESTINATIONS,
} from "../services/printer/printerConfigService";
import { orderService } from "../services/OrderService";
import { printQueueService } from "../services/printer/printQueueService";
import { printQueueWorker } from "../services/printer/printQueueWorker";
import { toast } from "react-hot-toast";

const PROCESSED_ORDERS_KEY = "processed_orders";

export const useOrderPrinting = () => {
  // console.log("---------------------- useOrderPrinting ----------------------")
  const lastProcessedOrders = useRef(
    new Set(JSON.parse(localStorage.getItem(PROCESSED_ORDERS_KEY) || "[]"))
  );
  const pollingInterval = useRef(null);

  const saveProcessedOrders = () => {
    const ordersArray = Array.from(lastProcessedOrders.current);
    localStorage.setItem(PROCESSED_ORDERS_KEY, JSON.stringify(ordersArray));
  };

  const checkAndQueueNewOrders = async () => {
    try {
      const result = await orderService.listOrders();

      if (result.success && result.data.length > 0) {
        const newOrders = result.data.filter(
          (order) =>
            !lastProcessedOrders.current.has(order._id) &&
            order.status === "En Preparacion"
        );

        for (const order of newOrders) {
          console.log("JOB Printer Orders from Client ", order);

          const orderItems = {
            kitchen: order.items.filter(
              (item) => item.destination === "Cocina"
            ),
            bar: order.items.filter(
              (item) =>
                item.destination === "Barra" || item.destination === "Bebidas"
            ),
          };

          // Imprimir en cocina
          if (orderItems.kitchen.length > 0) {
            const kitchenPrinters = printerConfigService
              .getPrintersByDestination(PRINT_DESTINATIONS.KITCHEN)
              .filter((printer) => printer.config.printKitchenOrders);

            for (const printer of kitchenPrinters) {
              printQueueService.addToQueue({
                type: "KITCHEN_ORDER",
                printerId: printer.id,
                order: {
                  ...order,
                  items: orderItems.kitchen,
                },
              });
            }
          }

          // Imprimir en barra
          if (orderItems.bar.length > 0) {
            const barPrinters = printerConfigService
              .getPrintersByDestination(PRINT_DESTINATIONS.BAR)
              .filter((printer) => printer.config.printBarOrders);

            for (const printer of barPrinters) {
              printQueueService.addToQueue({
                type: "BAR_ORDER",
                printerId: printer.id,
                order: {
                  ...order,
                  items: orderItems.bar,
                },
              });
            }
          }

          // Marcar orden como procesada
          lastProcessedOrders.current.add(order._id);
        }

        // Guardar órdenes procesadas
        if (newOrders.length > 0) {
          saveProcessedOrders();
        }
      }
    } catch (error) {
      console.error("[checkAndQueueNewOrders] Error:", error);
      toast.error("Error al procesar nuevas órdenes");
    }
  };

  useEffect(() => {
    // Iniciar el worker de la cola de impresión
    printQueueWorker.start();

    // Ejecutar inmediatamente al montar el componente
    checkAndQueueNewOrders();

    // Configurar el intervalo de polling
    pollingInterval.current = setInterval(checkAndQueueNewOrders, 5000);

    // Limpiar al desmontar
    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
      printQueueWorker.stop();
    };
  }, []);
};
